const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">Privacy Policy</h1>
        <p className="text-gray-600 mb-8">Last updated: November 2025</p>

        <div className="prose prose-lg max-w-none space-y-8 text-gray-700">
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">1. Introduction</h2>
            <p>
              Acuity Practice ("we," "us," "our," or "Company") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">2. Information We Collect</h2>
            <p>We may collect information about you in a variety of ways. The information we may collect on the site includes:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Personal Data:</strong> Name, email address, phone number, practice information</li>
              <li><strong>Payment Information:</strong> Billing address, payment method details (processed securely through Stripe)</li>
              <li><strong>Clinical Data:</strong> Session notes, client information, and health-related records (for authorized users only)</li>
              <li><strong>Usage Data:</strong> Browser type, IP address, pages visited, time and date of visits</li>
              <li><strong>Cookies:</strong> We use cookies to enhance your experience on our platform</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">3. Use of Your Information</h2>
            <p>Having accurate information about you permits us to provide you with a smooth, efficient, and customized experience. Specifically, we may use information collected about you via the site to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Process your transactions and send related information</li>
              <li>Email you regarding your account or subscription</li>
              <li>Fulfill and manage your orders</li>
              <li>Generate a personal profile about you</li>
              <li>Improve our website and services</li>
              <li>Monitor and analyze trends, usage, and activities</li>
              <li>Detect, prevent, and address fraud and security issues</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">4. HIPAA Compliance</h2>
            <p>
              Acuity Practice is designed to comply with the Health Insurance Portability and Accountability Act (HIPAA). We maintain administrative, physical, and technical safeguards to protect protected health information (PHI). Our system implements encryption, access controls, and audit logging to ensure the confidentiality, integrity, and availability of clinical data.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">5. Disclosure of Your Information</h2>
            <p>We may share information we have collected about you in certain situations:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>By Law or to Protect Rights:</strong> If required by law or to protect our legal rights</li>
              <li><strong>Service Providers:</strong> To vendors, consultants, and service providers who assist us in operating our website and conducting our business</li>
              <li><strong>Business Transfers:</strong> In the event of a merger, acquisition, or bankruptcy</li>
              <li><strong>Client Consent:</strong> Only with explicit consent for sharing clinical information</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">6. Security of Your Information</h2>
            <p>
              We use administrative, technical, and physical security measures to protect your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your personal information, we cannot guarantee its absolute security.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">7. Contact Us</h2>
            <p>
              If you have questions or comments about this Privacy Policy, please contact us at:
            </p>
            <p>
              <strong>Acuity Practice</strong><br />
              Trust Tech Digital<br />
              <a href="mailto:privacy@acuitypractice.com" className="text-primary-500 hover:text-primary-600">privacy@acuitypractice.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicyPage
